import { ShoesState } from 'src/types'

const mountainShapeMiddleCutOpening = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  if (['lowCut', 'quarterCut', 'unselected'].includes(state.openingPattern.value)) return

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.middleCutOpening.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(542, 192)
  ctx.quadraticCurveTo(591, 216, 591, 216)
  ctx.quadraticCurveTo(575, 230, 636, 264)
  ctx.quadraticCurveTo(688, 295, 726, 286)
  ctx.quadraticCurveTo(761, 285, 782, 262)
  ctx.quadraticCurveTo(790, 256, 795, 245)
  ctx.quadraticCurveTo(797, 235, 804, 238)
  ctx.quadraticCurveTo(815, 234, 834, 248)
  ctx.quadraticCurveTo(836, 238, 830, 228) // 右上
  ctx.quadraticCurveTo(805, 210, 782, 215)
  ctx.quadraticCurveTo(710, 210, 695, 195)
  ctx.quadraticCurveTo(620, 140, 542, 192)

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(590, 218) // 左
  ctx.quadraticCurveTo(622, 185, 695, 234)
  ctx.quadraticCurveTo(724, 251, 794, 249)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  ctx.lineWidth = 1.0
  ctx.fillStyle = state.tongueLinings.color
  ctx.beginPath()
  ctx.moveTo(542, 192)
  ctx.quadraticCurveTo(548, 195, 548, 195)
  ctx.quadraticCurveTo(606, 157, 668, 190)
  ctx.quadraticCurveTo(690, 212, 732, 218)
  ctx.quadraticCurveTo(760, 228, 823, 223)
  ctx.quadraticCurveTo(805, 210, 782, 215)
  ctx.quadraticCurveTo(710, 210, 695, 195)
  ctx.quadraticCurveTo(620, 140, 542, 192)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const horizontalShapeMiddleCutOpening = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  if (['lowCut', 'quarterCut', 'unselected'].includes(state.openingPattern.value)) return

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.middleCutOpening.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(542, 192)
  ctx.quadraticCurveTo(591, 216, 591, 216)
  ctx.quadraticCurveTo(575, 230, 636, 264)
  ctx.quadraticCurveTo(688, 295, 726, 286)
  ctx.quadraticCurveTo(761, 285, 782, 262)
  ctx.quadraticCurveTo(790, 256, 795, 245)
  ctx.quadraticCurveTo(797, 235, 804, 238)
  ctx.quadraticCurveTo(815, 234, 834, 248)
  ctx.quadraticCurveTo(836, 238, 830, 228) // 右上
  ctx.quadraticCurveTo(620, 185, 620, 185)
  ctx.quadraticCurveTo(583, 176, 542, 192)

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.0
  ctx.fillStyle = state.tongueLinings.color
  ctx.beginPath()
  ctx.moveTo(550, 199)
  ctx.quadraticCurveTo(589, 186, 615, 194)
  ctx.quadraticCurveTo(785, 230, 785, 229)
  ctx.quadraticCurveTo(847, 235, 828, 228)
  // ctx.quadraticCurveTo()
  ctx.quadraticCurveTo(805, 216, 782, 216)
  ctx.quadraticCurveTo(695, 195, 695, 195)
  ctx.quadraticCurveTo(590, 169, 550, 189)
  ctx.quadraticCurveTo(545, 199, 545, 199)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const middleCutOpening = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  if (['mountainMiddleCut'].includes(state.openingPattern.value)) {
    mountainShapeMiddleCutOpening(ctx, state)
  }
  if (['horizontalMiddleCut'].includes(state.openingPattern.value)) {
    horizontalShapeMiddleCutOpening(ctx, state)
  }
}
